import { useState } from 'react'
import { motion } from 'framer-motion'
import faqarrow from '../../../assets/images/icons/faqarrow.svg'
import Constants from '../../../app/utils/constants'

const WRAPPER_BG = '#110B2B'
const ROW_BG = '#0F0926'
const ROW_BG_OPEN = '#191040'

const GRADIENT = 'linear-gradient(135deg, #EA892A 0%, #F0578B 100%)'

const iconMaskBase = {
  WebkitMaskImage: `url(${faqarrow})`,
  maskImage: `url(${faqarrow})`,
  WebkitMaskSize: 'contain',
  maskSize: 'contain',
  WebkitMaskRepeat: 'no-repeat',
  maskRepeat: 'no-repeat',
  WebkitMaskPosition: 'center',
  maskPosition: 'center',
} as const

const ContactUsFaq = () => {
  const [openId, setOpenId] = useState<string | null>(null)
  const { contactUsSection } = Constants

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id))
  }

  return (
    <div
      className="relative mx-auto md:w-[90%] lg:w-[80%] 2xl:w-[70%] overflow-hidden md:rounded-3xl px-5 py-10 md:px-10 md:py-12"
      style={{ backgroundColor: WRAPPER_BG }}
    >
      <style>{`
        @keyframes faqOrbitCorners {
          0% {
            top: -18%;
            left: -12%;
          }
          25% {
            top: -18%;
            left: 82%;
          }
          50% {
            top: 78%;
            left: 82%;
          }
          75% {
            top: 78%;
            left: -12%;
          }
          100% {
            top: -18%;
            left: -12%;
          }
        }
      `}</style>

      <span
        aria-hidden
        className="pointer-events-none absolute h-52 w-52 rounded-full bg-[#ea8a2a65]/20 blur-3xl md:h-64 md:w-64"
        style={{
          animation: 'faqOrbitCorners 22s linear infinite',
          willChange: 'top, left',
        }}
      />
      <span
        aria-hidden
        className="pointer-events-none absolute h-52 w-52 rounded-full bg-[#ea8a2a65]/20 blur-3xl md:h-64 md:w-64"
        style={{
          animation: 'faqOrbitCorners 22s linear infinite',
          animationDelay: '-11s',
          willChange: 'top, left',
        }}
      />

      <div className="relative z-10 flex flex-col gap-3 md:gap-6">
        {contactUsSection.faqItems.map((item, index) => {
          const isOpen = openId === item.id
          return (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, margin: '-100px' }}
              transition={{ duration: 0.6, ease: 'easeOut', delay: index * 0.12 }}
            >
              <div
                className="overflow-hidden rounded-xl md:rounded-2xl transition-colors duration-500"
                style={{ backgroundColor: isOpen ? ROW_BG_OPEN : ROW_BG }}
                onMouseEnter={() => setOpenId(item.id)}
                onMouseLeave={() => setOpenId(null)}
              >
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => toggle(item.id)}
                  onFocus={() => setOpenId(item.id)}
                  className="flex w-full items-center gap-3 px-4 py-4 text-left md:gap-5 md:px-6 md:py-5 2xl:px-10 2xl:py-10"
                >
                  <span
                    className={`shrink-0 font-gilroy-bold text-base tabular-nums md:text-lg lg:text-xl xl:text-2xl 2xl:text-2xl ${
                      isOpen
                        ? 'bg-[linear-gradient(135deg,#EA892A_0%,#F0578B_100%)] bg-clip-text text-transparent'
                        : 'text-white'
                    }`}
                  >
                    {item.id}.
                  </span>
                  <span className="min-w-0 flex-1 font-gilroy-medium text-sm text-white md:text-base lg:text-lg xl:text-xl 2xl:text-2xl">
                    {item.question}
                  </span>
                  <span
                    className={`h-4 w-4 shrink-0 transition-transform duration-700 ease-out md:h-5 md:w-5 ${isOpen ? 'rotate-90' : ''}`}
                    style={
                      isOpen
                        ? { ...iconMaskBase, backgroundImage: GRADIENT }
                        : { ...iconMaskBase, backgroundColor: '#FFFFFF' }
                    }
                  />
                </button>

                <div
                  className={`grid transition-all duration-700 ease-out ${
                    isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <div className="px-5 pb-4 md:px-5 lg:px-14 xl:px-15 2xl:px-16 md:pb-5">
                      {item.answers.map((line) => (
                        <span
                          key={line}
                          className="mr-5 mb-5 inline-flex max-w-full min-w-0 w-fit rounded-full border border-purple/10 bg-purple/10 px-3 py-2 text-sm leading-snug text-white/90 wrap-break-word transition-transform duration-200 ease-out hover:scale-105 md:rounded-full md:px-4 md:py-2.5 md:text-base md:leading-relaxed lg:text-lg xl:text-xl 2xl:text-2xl"
                        >
                          {line}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          )
        })}
      </div>

    </div>
  )
}

export default ContactUsFaq
